import { MrfiktivHttpClientProvider } from "@/services/mrfiktiv/mrfiktiv-http-client.provider";
import { HandoverSnapshotSignRequest } from "../v1/HandoverSnapshotSignRequest";
import {
  MrfiktivCreateSnapshotSignRequestDtoGen,
  MrfiktivSnapshotSignRequestControllerFindAllParamsGen,
  MrfiktivUpdateSnapshotSignRequestStatusDtoGen
} from "../v1/data-contracts";

/**
 * Communicate with Snapshot Sign Request API
 */
class SnapshotSignRequestService {
  private proxy: HandoverSnapshotSignRequest;

  /**
   * Construct service
   */
  constructor(mrfiktivHttpClientProvider: MrfiktivHttpClientProvider) {
    this.proxy = new HandoverSnapshotSignRequest(mrfiktivHttpClientProvider.client());
  }

  /**
   * Create a sign request for a snapshot
   */
  async create(partnerId: string, dto: MrfiktivCreateSnapshotSignRequestDtoGen) {
    return (await this.proxy.snapshotSignRequestControllerCreate(partnerId, dto)).data;
  }

  /**
   * Get all sign requests for a partner (filtered server-side if needed)
   */
  async getAll(query: MrfiktivSnapshotSignRequestControllerFindAllParamsGen) {
    return (await this.proxy.snapshotSignRequestControllerFindAll(query)).data;
  }

  /**
   * Get one sign request by id
   */
  async getOne(partnerId: string, id: string) {
    return (await this.proxy.snapshotSignRequestControllerGetOne(partnerId, id)).data;
  }

  /**
   * Remove a sign request by id
   */
  async remove(partnerId: string, id: string) {
    return (await this.proxy.snapshotSignRequestControllerDelete(partnerId, id)).data;
  }

  async updateStatus(partnerId: string, id: string, data: MrfiktivUpdateSnapshotSignRequestStatusDtoGen) {
    return (await this.proxy.snapshotSignRequestControllerUpdateStatus(partnerId, id, data)).data;
  }
}

/**
 * Communicate with Snapshot Sign Request API
 */
export default new SnapshotSignRequestService(new MrfiktivHttpClientProvider());
